import React from 'react'

import { mergeDeep } from '@root/utility'

import Link from '@Pure/Link'

const moment = window.moment;

export var form =
{
	model: 'synerquizz',

	form_title: 'Syner\'Quizz',

	fields:
	{
		title:
		{
			label: 'Titre'
		},

		start:
		{
			label: 'Date et heure du quizz',
			type: 'datetime-local'
		},

		end:
		{
			label: 'Date et heure de fin de quizz',
			type: 'datetime-local'
		},

		reward:
		{
			label: 'Message (de la notification)',
			type: 'text'
		},

		question:
		{
			label: 'Question'
		},

		description:
		{
			label: 'Courte description du lot à gagner'
		},

		ec_admins_only:
		{
			label: 'Limiter aux élus de CSE',
			type: 'checkbox'
		},

		'notified':
		{
			label: 'Notification envoyée',
			type: 'text',

			valueHook: function (value, data, name)
			{
				return [true, 'true'].includes(value)
				? 'Oui'
				: 'Non'
			},

			readOnly: true
		},

		'reward_pdfs':
		{
			label: 'PDF/Image',
			type: 'image',
			multiple: true
		},

		'good_answers[text]':
		{
			type: 'text'
		},

		'wrong_answers[text]':
		{
			type: 'text'
		}
	},

	collapses:
	[
		{
			type: 'collapse',
			title: 'Général',
			elements:
			[
				'title',
				'start',
				'end',
				'notified',
				'question',
				'description',
				'ec_admins_only',
				{
					type: 'table',
					table_name: 'good_answers',
					columns:
					{
						'Bonnes réponses' : 'good_answers[text]'
					},
					add: true,
					add_label: 'Ajouter une bonne réponse'
				},
				{
					type: 'table',
					table_name: 'wrong_answers',
					columns:
					{
						'Mauvaises Réponses' : 'wrong_answers[text]'
					},
					add: true,
					add_label: 'Ajouter une mauvaise réponse'
				}
			]
		},
		{
			type: 'collapse',
			title: 'Récompense',
			elements:
			[
				'reward',
				'reward_pdfs'
			]
		}
	],

	repeatable:
	[
		'good_answers',
		'wrong_answers'
	],

	create_label: 'Créer ce synerquizz',

	get__deleteModalText: function (form_data)
	{
		var output =
		(
			<span>
				<p>Êtes vous sûr(e) de vouloir supprimer ce Syner'Quizz&nbsp;?</p>

				<div className="u-center">

					<div className="name-in-modal">
						{ form_data['synerquizz[title]'] }
					</div>

				</div>
			</span>
		);

		return output;
	},

	get__createdMessage: function (model)
	{
		return (
			<div className="c-message c-message--green">
				<div className="c-message__content">
					Le nouveau Syner'Quizz <strong> { model.title } </strong> a été créée.
					{ ' ' }
					<Link className="c-link c-link--highlighted c-link--green"
						href={ '/configuration/syner-quizz/' + model.id }>
						Voir le Syner'Quizz
					</Link>
				</div>
			</div>
		);
	},

	hookGetDataAjax: function (form_data, response)
	{
		['end', 'start'].filter(field => form_data['synerquizz[' + field + ']'])
		.forEach(function (field)
		{
			form_data['synerquizz[' + field + ']'] = moment(
				form_data['synerquizz[' + field + ']']
			)
			.format('YYYY-MM-DD[T]HH[:]mm');
		});
	}
}

export var list =
{
	model         : 'synerquizz',
	title         : 'Liste des Syner\'Quizz',
	link          : '/configuration/syner-quizz',
	creation_link : '/configuration/syner-quizz/nouveau',
	creation_label: 'Nouveau Syner\'Quizz',
	header_map:
	{
		'Titre': 'title',
		'Début': 'start',
		'Fin': 'end',
		'Gagnant': 'winner',
		'Terminé': 'completed'
	},
	row_link_base: '/configuration/syner-quizz/',
	searched_prop: 'title'
};

var config = mergeDeep({ }, form);

mergeDeep(config, list);

export default config;